
import { defineComponent } from 'vue';

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';

export default defineComponent({
  name: 'SBtnClear',
  components: { SBtn },
  props: {
    label: {
      type: String,
      default: 'Очистить фильтры',
    },
  },
  setup(props, { slots }) {
    return { props, slots };
  },
});
